import { useQuery } from "@tanstack/react-query";

import type { SiteSettings } from "@dteba/shared";

import { apiRequest } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import { useLocale } from "@/features/i18n/locale-provider";

/**
 * Contact details, rates and the accept-bookings switch. Every layout depends
 * on it, so it is cached for the session rather than refetched per page.
 */
export function useSiteSettings() {
  const { locale } = useLocale();

  return useQuery({
    queryKey: queryKeys.settings(locale),
    queryFn: () => apiRequest<SiteSettings>("/settings", { locale }),
    staleTime: 30 * 60 * 1000,
  });
}
